/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".image-preview[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{border:1px solid #b0b0b0;border-radius:5px;margin:5px 0}"];
export { styles as styles };
